import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark px-4 py-12 border-t border-dark-light">
      <div className="max-w-6xl mx-auto">
        <div className="mb-10">
          <img 
            src={require("../../assets/icons/ValetPeLogo.avif")} 
            alt="ValetPe Logo" 
            className="h-10"
          />
        </div>
                
      </div>
    </footer>
  );
};

export default Footer;